module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading center-element"
  }, [_c('span', {
    staticClass: "msg center-element"
  }, [_c('h3', [_vm._v("Aguarde")]), _c('pulse-loader')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f29b3c6"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Loading.vue
// module id = 431
// module chunks = 2